import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PieChartOutlinedSvg from "@ant-design/icons-svg/es/asn/PieChartOutlined";
import AntdIcon from '../components/AntdIcon';

var PieChartOutlined = function PieChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PieChartOutlinedSvg
  }));
};

PieChartOutlined.displayName = 'PieChartOutlined';
export default /*#__PURE__*/React.forwardRef(PieChartOutlined);